<template>
	<div class="dialogCon" >
		<el-dialog
		width="624px"
		 title="修改密码"
		 :visible.sync="dialogFormVisible"
		 :close-on-click-modal="false"
		 center=""
		 @close="submitTapX('ruleForm')">
		  <el-form  :model="form" :rules="rules" ref="ruleForm" label-width="100px"  >
			  <el-form-item label="旧密码:" prop="oldMi" :label-width="formLabelWidth"  >
			  	<el-input v-model="form.oldMi" type="password"  placeholder="请输入旧密码" autocomplete="off" ></el-input>
			  </el-form-item>
		    <el-form-item label="新密码:" prop="newMi" :label-width="formLabelWidth">
				<el-input v-model="form.newMi" type="password"  placeholder="请输入新密码" autocomplete="off" ></el-input>
		    </el-form-item>
			 <el-form-item label="确认密码:" prop="confirmMi" :label-width="formLabelWidth">
				<el-input v-model="form.confirmMi" type="password"  placeholder="请输入确认密码" autocomplete="off" ></el-input>
			</el-form-item>
			
		<!-- 	 <el-form-item label="获取验证码:" prop="gitCode" :label-width="formLabelWidth">
				<el-input v-model="form.gitCode" placeholder="请输入验证码" autocomplete="off" ></el-input>
			</el-form-item> -->
			
			<el-form-item label="获取验证码:" prop="gitCode" :label-width="formLabelWidth">
				<el-input v-model="form.gitCode" placeholder="请输入验证码" type="text"  autocomplete="off" style="width:200px;"></el-input>
				 <!-- <template slot="append"> -->
					 <el-button v-if="sendMobileCode" @click="sendMobile">获取短信验证码</el-button>
					 <el-button v-if="!sendMobileCode">{{limit_time}}秒后重新发送验证码</el-button>
				<!-- </template> -->
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button  @click="submitTapX('ruleForm')">取 消</el-button>
		    <el-button type="FF7" @click="submitFormX('ruleForm')" :loading="loading" >保 存</el-button>
		  </div>
		</el-dialog>
</div>
</template>

<script>
	import md5 from 'md5';
	export default {
		
		name:'addEmployee',
		props:['status'],
		data() {
		  return {
			  limit_time:0,
			sendMobileCode:true,
			loading:false,
			dialogFormVisible:false,
			formLabelWidth:"110px",
			form:{
				oldMi:"",
				newMi:"",
				confirmMi:"",
				gitCode:"",
			},
			
			rules: {
			  oldMi: [
				{ required: true, message: '请输入旧密码', trigger: 'blur' }
			  ],
			  newMi: [
			  	{ required: true, message: '请输入新密码', trigger: 'blur' },
				{ min: 6,  message: '密码最低长度为6位，支持字母、数组、特殊字符', trigger: 'blur' }
			  ],
			  confirmMi: [
			  	{ required: true, message: '请输入确认密码', trigger: 'blur' }
			  ],
			  gitCode: [
			  	{ required: true, message: '请输入验证码', trigger: 'blur' }
			  ],

			  
			},

			// limit:9,
		  };
		},
		watch:{
			status(val){
				 this.dialogFormVisible = val
			}
		},
		
		mounted(){
				 // this.getInfo();
		},
		
		methods:{
			//获取验证码
			sendMobile(){
			    var smsParams = {
                    'x_account_type':'merchant_user',
			        'method' :'com.set.merchant_user.info.sms',
			        'data':{
						'type':'reset-password'
			        }
			    };
			
			    this.$ajax(smsParams).then(res => {
			        if(res.status === 10000){
			            this.$message.success("发送短信成功");
			            this.sendMobileCode = false;
			            this.limit_time = 60;
			            var  time_timer = setInterval(()=>{
			                this.limit_time --;
			                if(this.limit_time <= 0){
			                    this.sendMobileCode = true;
			                    clearInterval(time_timer);
			                }
			            },1000);
			        }else{
			            this.$message.error(res.info);
			        }
			    });
			},
			//获取信息
// 			getInfo(){
// 				      this.$ajax({
// 						'method': 'com.set.merchant.staff.save',
// 						'data': {
// 							'merchant_staff_mobile': this.form.phone,
// 							'merchant_staff_nick': this.form.name,
// 						},
// 					}).then(res => {
// 						if (res.status == 10000) {
// 							this.messages(res.info, 'success');
// 							this.$emit('add',false,'')
// 						} else {
// 							this.messages(res.info, 'warning');
// 						}
// 					});
// 			},
			
			
			btnEditX(){
				this.editOr=false;
			},
			// 取消
			submitTapX(formName){
				// this.dialogFormVisible=false;
				this.$emit('add',false)
				  this.$refs[formName].resetFields();
			},
			//保存zzz
			submitFormX(formName) {
 				this.$refs[formName].validate((valid) => {
 				  if (valid) {
					  if(this.form.confirmMi!=this.form.newMi){
						  this.messages('新密码与确认密码不一致！', 'warning');
						  return;
					  }
					  
	                this.$ajax({
						    'x_account_type':'merchant_user',
							'method': 'com.set.merchant_user.info.reset_pwd',
							'data': {
						        'old_password':md5(this.form.oldMi),
								'password': md5(this.form.newMi),
								"verify_code":this.form.gitCode,
							},
						}).then(res => {
							if (res.status == 10000) {
								this.loading = false;
								this.messages(res.info, 'success');
								this.dialogFormVisible = false;
								this.$emit('add',false,'')
								sessionStorage.removeItem('user');
								this.$router.push('/login');
								
							} else {
								this.loading = false;
								this.messages(res.info, 'warning');
							}
						});
				  } 
 				});
			}
		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
.dialogCon .el-input{width: 440px;}
.dialogCon .el-dialog__wrapper .el-dialog{width:634px !important;}
.editItem{margin-left: 30px;width:400px;height:50px;line-height: 50px;}
.labell{display: inline-block;width:90px;text-align: right;}

</style>


// WEBPACK FOOTER //
// updateMi.vue?2c77aa76